import clsx from 'clsx'
import {NavLink} from 'react-router-dom'

import {trlObject} from '~/services/intl'

import type {TopicItem} from './DocumentationSidebar'

type Props = {
    item: TopicItem
    path: string
}

export default function DocumentationSidebarTreeLink({item, path}: Props) {
    return <NavLink
        to={path}
        className={({isActive}) => clsx(
            'documentation-menu__item',
            isActive && 'documentation-menu__item_active'
        )}
    >
        {item.path && trlObject('documentation')[item.path]}
        {item.type && ` (${item.type})`}
    </NavLink>
}
